<template>
    <div>
        <auth-header></auth-header>
        <router-view></router-view>
    </div>
</template>

<script>
    import AuthHeader from "../../../components/menu/AuthHeader";
    export default {
        components:{
            AuthHeader
        }
    }
</script>
